import React from 'react';
import styled from 'styled-components';
const CheckboxWrapper = styled.div `
  height: 48px;
  width: 48px;
  position: absolute;
  top: 0;
  left: 0;
  .control {
    display: block;
    position: relative;
    cursor: pointer;
  }
  .control input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  .control_indicator {
    position: absolute;
    top: 14px;
    left: 10px;
    height: 20px;
    width: 20px;
    background: #fff;
    border: 1px solid #000000;
  }
  .control-radio .control_indicator {
    border-radius: undefined%;
  }

  .control input:checked ~ .control_indicator {
    background: #000000;
  }

  .control_indicator:after {
    box-sizing: unset;
    content: '';
    position: absolute;
    display: none;
  }
  .control input:checked ~ .control_indicator:after {
    display: block;
  }
  .control-checkbox .control_indicator:after {
    left: 7px;
    top: 3px;
    width: 3px;
    height: 8px;
    border: solid #ffffff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
const Checkbox = ({ user, selectUser, checked, onClick }) => (React.createElement(CheckboxWrapper, { id: user.id },
    React.createElement("label", { className: "control control-checkbox" },
        React.createElement("input", { type: "checkbox", id: user.id, onChange: () => selectUser(user.id), checked: checked ? true : user.selected, onClick: onClick }),
        React.createElement("div", { className: "control_indicator" }))));
export default Checkbox;
